import { render, staticRenderFns } from "./CustomerPageVisioCard.vue?vue&type=template&id=0f656684&"
import script from "./CustomerPageVisioCard.vue?vue&type=script&lang=js&"
export * from "./CustomerPageVisioCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports